import { call, put, select, takeLatest } from 'redux-saga/effects';

import authService from 'services/authService';

import { getUserId } from 'store/session/selectors';

import { setToken } from 'utils/token';

import {
  superUserChangeUserGroup,
  groupMemberChangeUserGroup,
  types,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.GROUP_MEMBER_CHANGE_USER_GROUP_REQUEST,
    watchGroupMemberChangeUserGroup,
  );
  yield takeLatest(
    types.SUPER_USER_CHANGE_USER_GROUP_REQUEST,
    watchSuperUserChangeUserGroup,
  );
}

function* watchGroupMemberChangeUserGroup(action) {
  try {
    const { groupMemberId, nextUrl } = action.payload;
    const { token } = yield call(
      authService.switchActiveUserGroup,
      groupMemberId,
    );

    yield call(setToken, token);
    if (nextUrl) {
      window.location.replace(nextUrl);
    } else {
      window.location.reload(true);
    }
    yield put(groupMemberChangeUserGroup.success());
  } catch (e) {
    yield put(groupMemberChangeUserGroup.error(e));
  }
}

function* watchSuperUserChangeUserGroup(action) {
  try {
    const { userGroupId, nextUrl } = action.payload;
    const userId = yield select(getUserId);
    const { token } = yield call(authService.updateActiveGroup, userId, {
      activeGroupId: userGroupId,
    });

    yield call(setToken, token);
    if (nextUrl) {
      window.location.replace(nextUrl);
    } else {
      window.location.reload(true);
    }

    yield put(superUserChangeUserGroup.success());
  } catch (e) {
    yield put(superUserChangeUserGroup.error(e));
  }
}
